var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12152_13490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8537 7.35414L9.85371 12.3541C9.78378 12.4241 9.69466 12.4718 9.59762 12.4912C9.50057 12.5105 9.39998 12.5006 9.30857 12.4627C9.21716 12.4248 9.13904 12.3607 9.0841 12.2784C9.02917 12.1961 8.99988 12.0993 8.99996 12.0004V9.51477C5.43121 9.71727 2.98434 12.0316 2.29746 12.7648C2.18961 12.88 2.04817 12.9582 1.89328 12.9883C1.73838 13.0185 1.57793 12.999 1.43475 12.9327C1.29157 12.8663 1.17295 12.7565 1.09579 12.6189C1.01863 12.4812 0.986842 12.3228 1.00496 12.166C1.23684 10.1498 2.34121 8.21039 4.11496 6.70539C5.58809 5.45539 7.37871 4.66227 8.99996 4.52352V2.00039C8.99988 1.90145 9.02917 1.8047 9.0841 1.7224C9.13904 1.64011 9.21716 1.57596 9.30857 1.53808C9.39998 1.50021 9.50057 1.4903 9.59762 1.50963C9.69466 1.52895 9.78378 1.57664 9.85371 1.64664L14.8537 6.64664C14.9002 6.69308 14.9371 6.74822 14.9622 6.80892C14.9874 6.86962 15.0004 6.93469 15.0004 7.00039C15.0004 7.0661 14.9874 7.13117 14.9622 7.19186C14.9371 7.25256 14.9002 7.30771 14.8537 7.35414Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12152_13490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteShareIcon);
export default __webpack_public_path__ + "static/media/white-share-icon.005e4809499f18a0b431cb6c0a9f86fd.svg";
export { ForwardRef as ReactComponent };